import { render, staticRenderFns } from "./RightColumnQnASettings.vue?vue&type=template&id=2fb9c5c2&scoped=true&"
import script from "./RightColumnQnASettings.vue?vue&type=script&lang=js&"
export * from "./RightColumnQnASettings.vue?vue&type=script&lang=js&"
import style0 from "./RightColumnQnASettings.vue?vue&type=style&index=0&id=2fb9c5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9c5c2",
  null
  
)

export default component.exports